import { atom } from 'recoil';

import { recoilPersist } from 'recoil-persist';

import { ThanksSenderSuffix } from '../utils/thanksPrintMessage';

const { persistAtom } = recoilPersist({
  key: 'giftThanksPrint',
  storage: typeof window !== 'undefined' ? localStorage : undefined,
});

/**
 * 감사인쇄 입력값.
 * 감사글/발신자(이름·표현)는 인쇄 내용이라 상품과 무관하게 공통 → 주문하지 않아도 계속 보존하여
 * 다른 상품(감사인쇄 가능 브랜드) 주문 시에도 이어서 사용한다.
 * brandId/templateId(=디자인 타입)는 브랜드별로 다르므로, 같은 브랜드일 때만 복원/주문에 사용한다.
 */
export interface GiftThanksPrintState {
  /** 인쇄용 감사글 */
  message: string;
  /** 발신자 이름 (상주명, 없으면 OOO) */
  senderName: string;
  /** 발신 표현 (배상/드림/올림) */
  senderSuffix: ThanksSenderSuffix;
  /** 마지막으로 선택한 브랜드 id (템플릿 복원/주문 매칭용) */
  brandId?: string;
  /** 마지막으로 선택한 ThanksPrintTemplate._id */
  templateId?: string;
}

export const giftThanksPrintAtom = atom<GiftThanksPrintState | null>({
  key: 'giftThanksPrintAtom',
  default: null,
  effects_UNSTABLE: [persistAtom],
});
